
<template>
  <futuredeliveryreport-component>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Future Delivery</strong>
          </div>
           <b-row class="mb-3">
              <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
             <!--  <b-col md="4" class="my-1">
                <b-form-group label="Delivery Agent" :label-cols="6" >
                 <b-form-select class="form-control input" v-model="deliveryagentid" name="deliveryagentid" >
                        <option :value="selected" >--Select--</option>
                        <option v-for="agent in agentmaster" v-bind:value="agent.deliveryagentmasterid">{{ agent.deliveryagentmasterid}}-{{ agent.deliveryagentfirstname}} -{{ agent.deliveryagentlastname}}</option>
                  </b-form-select>
                </b-form-group>
              </b-col> -->
            <!--   <b-col md="2">
         <b-button type="submit" size="md" variant="primary" @click="showCSV"> Search</b-button>
              </b-col> -->
          </b-row>
          <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red; float: right;">{{ this.totalRows }}</span></b> </p>   
              </b-col>

            <b-table  show-empty stacked="md" :busy="isBusy" :items="items" :fields="fields"  :current-page="currentPage" :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" :bordered="bordered" >
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>

            <template slot="row-details" slot-scope="row">
              <b-card>
                <b-row>
                  <b-col sm="12">
                  <div slot="footer" class="text-right">
                   <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
                  </div>
                 </b-col>
                </b-row>

              </b-card>
            </template>

          </b-table>
          <b-col md="6" class="my-1" v-if="this.totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
  </div>
</futuredeliveryreport-component>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue';
import VueBarcode from 'vue-barcode';
export default {
  data: function() {
    return {
      data: [],
      checkedShipmentID:[],
      items:[],
      selected:'',
      isBusy: false,
      orderflow:'',
      Pickup:'',
      email:'',
      shipmenttype:'',
      shipmentstatus:'',
      hubid:'',
      deliveryagentid:'',
      agentmaster: [],
      showdata: [],
      hubdata:[],
      printdata:[],
      progressbar:[],
      progressbar:[],
      fields: [
          { key: 'orderid', label: 'Orderid', sortable: true, sortDirection: 'desc' },
          { key: 'awbno', label: 'AWBno', sortable: true},
          { key: 'customername', label: 'Customername', sortable: true},
          { key: 'futuredate', label: 'FutureDeliveryDate', sortable: true},
          { key: 'deliverystatus', label: 'DeliveryStatus', sortable: true },
          { key: 'shipmentstatus', label: 'ShipmentStatus', sortable: true },

        ],
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        isCheckAll: false,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
    };
  },
  computed: {
    sortOptions() {
        // Create an options list from our fields
        // return this.fields
        //   .filter(f => f.sortable)
        //   .map(f => {
        //     return { text: f.label, value: f.key }
        //   })
      }
  },
  created: function() {

    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.hubid=userInfo.pickuplocationmasterid.toString();
    //this.displayHubdata();
    this.displaydeliveryagent();
    this.showCSV();
  },
  methods: {
    info(item, shipmentid,index, button) {

      this.progressbar  = item;
      this.infoModal.title = 'Shipment Log - '+shipmentid;
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    validateForm(scope) {},
    trybuyaddawb:function() {
       var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
     const obj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
      
      };
       this.$http
        .post(`${CONSTANTS.API_URL}/getmisreport`,obj)
        .then(result => {
          if (result.data.returnmsg == "successful") {

            this.getDownloadCsvObject(result.data.returnvalue);


           alert('MIS Report Downloaded Successfully');
            //document.getElementById("loader").style.display = 'none';
          } else {
             alert(result.body.returnmsg);


          }
        }).catch(ex => {
          console.log("error-----", ex);
        });
     },
    getDownloadCsvObject: function(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "MISReport_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    downloadCSV: function() {
 var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
      var orderflow=(this.orderflow!=null)? this.orderflow:"";
      var deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid:"";
      var csvObj = {
        orderflow:orderflow,
        deliveryagentid:deliveryagentid,
         hub_id:`${userInfo.pickuplocationmasterid}`,
      
      };
      var r = Math.random().toString(36).substring(3);
      this.$http
        .post(`${CONSTANTS.API_URL}/getmisreport?c=`+r, csvObj)
        .then(result => {
          if (result.data.returnmsg == "successful") {

            this.getDownloadCsvObject(result.data.returnvalue);

           alert('MIS Report Downloaded Successfully');
            //document.getElementById("loader").style.display = 'none';
          } else {
             alert(result.body.returnmsg);


          }
        })
        .catch(ex => {
          console.log("error-----", ex);
        });
    },
    showCSV: function() {
       var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
 const obj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
      
      };
       this.isBusy = true;
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/futuredeliveryshipment`,obj)
          .then(result => {
             this.isBusy = !this.isBusy;

           
                this.items  = result.body.returnvalue

                this.totalRows = result.body.returnvalue.length;
          })
          

    },
    displayHubdata: function() {
       var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
      const deliveryagentobj = {
         hub_id:`${userInfo.pickuplocationmasterid}`,
      }
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getallhublist`)
        .then(result => {
          this.hubdata = result.body.returnvalue;
        })
        .catch(ex => {
          console.log('error-----', ex)
        });
    },

    displaydeliveryagent: function() {
       var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
         hub_id:`${userInfo.pickuplocationmasterid}`,
      }
this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          this.agentmaster = result.body
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    }

  }
};
</script>

<style lang="css">
.popover-container {
  width: 100%;
}
.popover-container input {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  max-width: 100%;
  width: 100%;
}
.table tr th {
  color: #fff !important;
}
.table thead,
.table thead tr:hover {
  background: #333 !important;
}
.table button {
  background: #b0c4de !important;
  color: #000 !important;
}
.table tr:hover {
  background: #efefef;
}
tbody tr:nth-child(even) {
  background: #f2f2f2;
}
tbody tr:nth-child(odd) {
  background: #fff;
}
.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #fff;
}
hr {
  margin-bottom: 0px;
}
.error {
  color: red;
}
button.editbtn {
  border: none;
  background: transparent !important;
}
.label {
  text-align: left;
}
.select {
  width: 100%;
}
@media all {
.page-break { display: none; }
}

@media print {
.page-break { display: block; page-break-before: always; }
}
.addpad{
  padding: 10px;
}        
</style>

